(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    class CartPreference extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
    }

    handleChange = async (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;

      try {
        const body = new URLSearchParams();
        body.set('attributes[No cutlery needed]', input.checked ? 'Yes' : '');

        const response = await fetch(`${Theme.routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });

        if (!response.ok) {
          throw new Error(`Cart preference update failed with status ${response.status}`);
        }

        const cart = await response.json();
        input.checked = cart.attributes?.['No cutlery needed'] === 'Yes';
      } catch (error) {
        console.warn('[cart-preference] Update failed:', error);
      }
    };
  }

  if (!customElements.get('cart-preference')) {
    customElements.define('cart-preference', CartPreference);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-cart-bar"] && !Shopify.designMode) return;
  try {
    class MobileCartBar extends HTMLElement {
    connectedCallback() {
      document.addEventListener('shopify:cart:lines-update', this.handleCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:cart:lines-update', this.handleCartUpdate);
    }

    handleCartUpdate = (event) => {
      event.promise
        ?.then(({ cart }) => {
          if (!cart) return;

          const quantity = cart.totalQuantity ?? 0;
          const money = cart.cost?.totalAmount;
          const count = this.querySelector('[data-cart-count]');
          const total = this.querySelector('[data-cart-total]');

          this.hidden = quantity === 0;
          if (count) count.textContent = String(quantity);
          if (total && money) {
            total.textContent = new Intl.NumberFormat(this.dataset.locale || undefined, {
              style: 'currency',
              currency: money.currencyCode,
              maximumFractionDigits: 0,
            }).format(Number(money.amount));
          }
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[mobile-cart-bar] Update failed:', error);
        });
    };
  }

  if (!customElements.get('mobile-cart-bar')) {
    customElements.define('mobile-cart-bar', MobileCartBar);
  }
  } catch(e) { console.error(e); }
})();

})();
